import * as React from 'react';
import { ISubcategoryNavigationViewProps } from './subcategory-navigation';
import classnames from 'classnames';
import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';
import { ArrayExtensions, generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { NavigationMenu } from '@msdyn365-commerce-modules/navigation-menu';
import { IImageData, IImageSettings, IRequestContext, Image } from '@msdyn365-commerce/core';

export default (props: ISubcategoryNavigationViewProps) => {
    const {
        data: { category },
        config: { className, imageSettings },
        context: {
            actionContext: { requestContext }
        }
    } = props;

    const categoryResult = category.result;
    if (!categoryResult || !categoryResult.Children || categoryResult.Children.length < 1) {
        return null;
    }

    const children = categoryResult.Children;
    return (
        <ul role='menu' className={classnames('hei-subcategory__nav', className)}>
            {children.map(c => renderSubcategoryItem(requestContext, c, imageSettings))}
        </ul>
    );
};

const renderSubcategoryItem = (requestContext: IRequestContext, subcategory: CategoryHierarchy, imageSettings?: IImageSettings) => {
    let imageSource: string = 'empty';
    if (ArrayExtensions.hasElements(subcategory.Images) && subcategory.Images[0].Uri) {
        imageSource = subcategory.Images[0].Uri;
    }

    const linkText = NavigationMenu.getFriendlyName(requestContext.locale, subcategory.NameTranslations) || '';
    return (
        <li key={subcategory.RecordId} className='hei-subcategory__nav__list__item' role='presentation'>
            <a className='hei-subcategory__nav__list__item__link' role='menuitem' href={subcategory.Url || ''}>
                {getCategoryImage(requestContext, imageSource, linkText, imageSettings)}
                <span className='hei-subcategory__nav__list__item__link__text'>{linkText}</span>
            </a>
        </li>
    );
};

const defaultImageSettings: IImageSettings = {
    viewports: {
        xs: { q: 'w=200&h=200&m=8', w: 0, h: 0 },
        sm: { q: 'w=200&h=200&m=8', w: 0, h: 0 },
        md: { q: 'w=200&h=200&m=8', w: 0, h: 0 },
        lg: { q: 'w=200&h=200&m=8', w: 0, h: 0 },
        xl: { q: 'w=200&h=200&m=8', w: 0, h: 0 }
    },
    quality: 80,
    lazyload: false
};

const getCategoryImage = (
    requestContext: IRequestContext,
    categoryImage: string,
    altText: string,
    imageSettings?: IImageSettings
): React.ReactNode | null => {
    const categoryImageUrl = generateImageUrl(categoryImage, requestContext.apiSettings);
    if (categoryImageUrl !== undefined) {
        const imageSettingsValue = {
            ...defaultImageSettings,
            imageSettings
        };

        const imageData: IImageData = {
            imageSettings: imageSettingsValue,
            src: categoryImageUrl,
            altText
        };

        return (
            <Image
                {...imageData}
                requestContext={requestContext}
                className='ms-nav-image__item'
                gridSettings={requestContext.gridSettings!}
                loadFailureBehavior='hide'
                role='tabpanel'
                id={`${categoryImage}__categoryImage`}
                bypassHideOnFailure
            />
        );
    }

    return null;
};
